import { render, staticRenderFns } from "./TableHeaderToolTipNew.vue?vue&type=template&id=f08af85c&scoped=true&"
import script from "./TableHeaderToolTipNew.vue?vue&type=script&lang=ts&"
export * from "./TableHeaderToolTipNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08af85c",
  null
  
)

export default component.exports